import Vue from 'vue'
import vm from '@/main.js'
import Urls from '@/utils/globel.js'
import {
  axios
} from '@/utils/request.js'
import {
  parseParam
} from '@/utils/util.js'
import ossService from '@/utils/oss.service'
import Utils from '@/utils/oss.util.js'
import {
  environment
} from '@/utils/oss.env'
let count = 0
const practice = {
  namespaced: true,
  state: {
    stuWorkInfo: [], // 做题信息
    taskData: [], // 业务列表
    dictType: [], //
    baseInfo: [], // 包含企业信息，字典信息和业务列表
    businessData: [], // 包含baseUrl,detailUrl,isNew等信息
    detailData: [],
    loginInfo: {
      eid: '',
      testId: '',
      stuId: '',
      domain: '',
      token: '',
      orgId: ''
    },
    curTaskData: {},
    isSubmit: 0,
    enterprise: {},
    allFinish: false,
  },
  getters: {
    TASK_DATA: state => {
      const taskData = Vue.ls.get('taskData')
      state.taskData = taskData
      return taskData
    },
    LOGIN_INFO: state => {
      const loginInfo = Vue.ls.get('loginInfo')
      return loginInfo
    },
    ENTERPRISE: () => {
      const enterprise = Vue.ls.get('enterprise')
      return enterprise
    },
  },
  mutations: {
    SET_STU_WORK_INFO: (state, info) => { // 做题信息
      state.stuWorkInfo = info
    },
    SET_TASK_DATA: (state, data) => { // 业务列表
      Vue.ls.set('taskData', data)
      state.taskData = data
    },
    SET_ENTERPRISE: (state, data) => {
      Vue.ls.set('enterprise', data)
      state.enterprise = data
    },
    SET_DICT_TYPE: (state, data) => { // 字典列表
      state.dictType = data
    },
    SET_BASE_INFO: (state, data) => { // 包含企业信息，字典信息和业务列表
      Vue.ls.set('baseInfo', data)
      state.baseInfo = data
    },
    SET_CUR_TASK_DATA: (state, data) => { // 当前业务信息
      state.curTaskData = data
    },
    SET_BUSINESS_DATA: (state, data) => { // business 接口的数据
      state.businessData = data
    },
  },
  actions: {
    // 通过logininfo获取业务列表 ,这边会根据state.loginfo里面有的属性来截取值并保存
    async getBusinessList({
      getters,
      commit,
      dispatch,
    }) {
      console.log('getters :>> ', getters)
      const param = parseParam({
        ...getters.LOGIN_INFO
      })
      await axios.post(Urls.getBusinessList + '&' + param)
        .then(async (res) => {
          if (res) {
            commit('SET_BUSINESS_DATA', res)
            await dispatch('loadBaseInfo', res)
          } else {
            return false
          }
        })
    },
    /**
     *
     * @param {*} data
     */
    async loadBaseInfo({
      state,
      commit,
      dispatch
    }, data) {
      const url = environment.huawei_source + data.baseUrl
      const res = await axios.get(url)
      const taskData = res.data
      const enterprise = res.enterprise
      // 格式化业务列表内容，将动态数据替换上去
      if (data.transMap) {
        enterprise['year'] = data.transMap['@year']
        enterprise['nextYear'] = data.transMap['@nextYear']
        enterprise['lastYear'] = data.transMap['@lastYear']
        for (const key in data.transMap) {
          for (const i in taskData) {
            const temp = taskData[i]
            const re = new RegExp(`${key}`, 'g')
            temp.content = temp.content.replace(re, data.transMap[key])
            temp['isFinish'] = '0'
          }
        }
      }
      if (data.isSubmit === '1') { // 全部结束
        state.isSubmit = 1
        dispatch('taskDateFinishAll')
        // commit('SET_TASK_DATA', taskData)
        commit('SET_ENTERPRISE', enterprise)
      } else {
        if (data.isNew !== '0') { // 0为新
          try {
            await dispatch('getTestByOSS', {
              url: environment.huawei_source + data.detailUrl,
              taskData: taskData
            })
          } catch (error) {
            console.log(error, 'load')
          }
          commit('SET_ENTERPRISE', enterprise)
        } else {
          commit('SET_TASK_DATA', taskData)
          commit('SET_ENTERPRISE', enterprise)
          const curTaskData = dispatch('resolveTask', taskData[0])
          commit('SET_CUR_TASK_DATA', curTaskData)
          taskData[0].isFinish = '1'
        }
      }
    },
    /**
     * 获取OSS上的做题记录
     * @param url
     * @param taskData
     */
    async getTestByOSS({
      state,
      commit,
      dispatch
    }, {
      url,
      taskData
    }) {
      try {
        const result = await axios.get(url)
        for (let i = 0; i < result.length; i++) {
          if (result[i].isFinish !== '2') {
            result[i].isFinish = '1'
            break
          }
        }
        if (result === null && result.length <= 0) return
        for (let i = 0; i < taskData.length; i++) {
          const sourceResult = taskData[i]
          for (let j = 0; j < result.length; j++) {
            const r = result[j]
            if (sourceResult.id === r.moduleId) {
              sourceResult.isFinish = r.isFinish
              sourceResult.status = r.status
              sourceResult['detailId'] = r.detailId
              break
            }
          }
        }
        commit('SET_TASK_DATA', taskData)
        commit('SET_CUR_TASK_DATA', taskData[0])
      } catch (error) {
        // oss detailUrl 获取失败重传
        const detailData = Vue.ls.get('detailData')
        const moduleData = detailData[0] // 取业务状态列表的任意一个数据，只是为了能够符合上传oss的格式所需的数据
        const isFinish = moduleData.isFinish
        await dispatch('uploadTestByOSS', {
          result: moduleData,
          isFinish: isFinish
        })
        if (count === 0) {
          await dispatch('getBusinessList')
          count++
        }
        console.log(error, 'getTestByOSS')
      }
    },
    /**
     * 上传做题记录到OSS
     */
    uploadTestByOSS({
      state,
      commit
    }, {
      result,
      isFinish
    }) {
      const uu = environment.dshDataUrl + Utils.getTestId() + '.o'
      const data = Utils.getTasksData()
      const detailId = result.detailId
      const moduleId = result.moduleId
      for (const item of data) {
        if (item.id === result.moduleId) {
          item.isFinish = isFinish
          item.detailId = detailId
          break
        }
      }
      return ossService.ossput(uu, data, moduleId, detailId).then((res) => {
        console.log(res)
        if (res === 200) {
          console.log(data)
          // vm.$message.success('结束成功')
        } else {
          ossService.ossput(uu, data, moduleId, detailId).then(res => {
            if (res === 200) {
              vm.$message.error('结束失败')
            }
          })
        }
        return res
      }).catch((error) => {
        vm.$error({
          title: '警告',
          content: error
        })
      })
      // if (this.allTaskFinish()) {
      //   // 当任务全部完成
      //   this.allFinish = true
      // }
    },
    /**
     * 全部任务的状态改为结束
     */
    taskDateFinishAll({
      state,
      getters,
      commit
    }) {
      state.allFinish = true
      const taskData = getters.TASK_DATA
      for (let i = 0; i < taskData.length; i++) {
        taskData.isFinish = 2
      }
      for (let i = 0; i < taskData.length; i++) {
        if (taskData[i].isFinish !== 2) {
          taskData[i].isFinish = 2
          taskData[i].status = 1
        }
      }
      commit('SET_TASK_DATA', taskData)
    },
    /**
     * 解析任务列表
     */
    resolveTask(obj) {
      obj.isNeedBtn = false
      obj.haveVideo = false
      obj.btnName = ''
      if (obj.isFinish !== '2') {
        if (obj.modType === '1' || obj.modType === '5' || obj.modType === '6' || obj.modType === '7' || obj.modType === '8') {
          obj.isNeedBtn = true
          obj.btnName = '结束业务'
        } else if (obj.modType === '3') {
          obj.isNeedBtn = true
          obj.btnName = '前往购买'
        }
      }
      if (obj.videoId) obj.haveVideo = true
      return obj
    },
    /**
     * 任务是否全部结束
     */
    taskIsAllFinish({
      state
    }) {
      const task = state.taskData
      for (let i = 0; i < task.length; i++) {
        if (task.isFinish !== 2) {
          return false
        }
      }
      return true
    },
    /**
     * 根据步骤获取taSke
     * @param key
     */
    getTasksBySeq({
      state
    }, seq) {
      const data = state.taskData
      if (data !== null && seq < data[seq] !== undefined) {
        return data[seq]
      }
      return null
    },
    /**
     * 从业务列表第四个开始查找第一个可操作的业务
     */
    getTaskByInvoice({
      state
    }) {
      const taskData = state.taskData
      let task
      for (let i = 0; i < taskData.length; i++) {
        if (taskData[i].isFinish !== '2' && (taskData[i].modType === '8' || taskData[i].modType === '1')) {
          task = taskData[i]
          return task
        }
      }
      return false
    },
  }
}
export default practice
